export const APP_LISTING_HOME_LINK = '/';

export const TEST_ID = {
  HEADER_ACTION_LINKS: 'app-listing__header-action-links',
  SERVER_EOL_MESSAGE: 'server-eol-warning-message',
  SERVER_EOS_MESSAGE: 'server-eos-warning-message',
} as const;

export const WARNING_MESSAGE = {
  SERVER_EOS_MESSAGE:
    'We no longer offer sales and support for server apps. You can stay connected by exploring the migration options to either the cloud or Data Center version of this app.',
  SERVER_EOL_MESSAGE_FOR_DATA_CENTER_SUPPORTED_APPS:
    'As new server app sales are no longer available on Atlassian Marketplace, you can use the Data Center version of this app to support server to cloud migration. The existing server app version can only be updated until the end of support for server on Feb 15,2024.',
  SERVER_EOL_MESSAGE_FOR_NON_DATA_CENTER_SUPPORTED_APPS:
    'As we continue to move towards a cloud future together, new server app sales and installs are no longer available for customers. You can update app version via Atlassian Marketplace until the end of support for server on Feb 15, 2024.',
} as const;
